import i18n from "features/shared/i18n";
import { AppUser } from "features/user/types";
import { translateProfileValues } from "./playerTabUtils";
import { ProfileFieldType } from "./ProfileFieldEditModal";

interface FavoritesSectionProps {
  selectedUser: AppUser;
  onEditField: (field: ProfileFieldType) => void;
}

export function FavoritesSection({ selectedUser, onEditField }: FavoritesSectionProps) {
  return (
    <div className="flex-col-el">
      <div className="flex-row-el items-center gap-3 py-3 border-b border-outline overflow-hidden">
        <div className="text-[18px] text-gray2-100 w-[120px] shrink-0">
          {i18n.t("MSG_PROFILE_AI_FAVORITE_COLOR_PARENT")}
        </div>
        <div className="flex-row-el items-center gap-2 w-[180px]">
          {selectedUser.favorite_color && selectedUser.favorite_color.length > 0 ? (
            selectedUser.favorite_color.map((color, idx) => (
              <div
                key={idx}
                className="w-[28px] h-[28px] rounded-full border border-gray2-40"
                style={{ backgroundColor: color }}
              />
            ))
          ) : (
            <span className="text-[21px] text-textcolor-black">
              {i18n.t("MSG_PARENT_PAGE_NOT_SET")}
            </span>
          )}
        </div>
        <button
          onClick={() => onEditField(ProfileFieldType.FAVORITE_COLOR)}
          className="bg-white border border-gray2-60 text-textcolor-black rounded-full py-1.5 px-3 text-[16px] cursor-pointer hover:bg-gray2-20 transition-all shrink-0"
        >
          {i18n.t("MSG_PARENT_PAGE_CHANGE")}
        </button>
      </div>
      <div className="flex-row-el items-center gap-3 py-3 border-b border-outline overflow-hidden">
        <div className="text-[18px] text-gray2-100 w-[120px] shrink-0">
          {i18n.t("MSG_PROFILE_AI_BEST_SUBJECTS_BY_PARENT")}
        </div>
        <div className="text-[21px] text-textcolor-black w-[180px] truncate">
          {translateProfileValues(selectedUser.best_subject)}
        </div>
        <button
          onClick={() => onEditField(ProfileFieldType.BEST_SUBJECT)}
          className="bg-white border border-gray2-60 text-textcolor-black rounded-full py-1.5 px-3 text-[16px] cursor-pointer hover:bg-gray2-20 transition-all shrink-0"
        >
          {i18n.t("MSG_PARENT_PAGE_CHANGE")}
        </button>
      </div>
      <div className="flex-row-el items-center gap-3 py-3 overflow-hidden">
        <div className="text-[18px] text-gray2-100 w-[120px] shrink-0">
          {i18n.t("MSG_PARENT_PAGE_PROFILE_NOTES")}
        </div>
        <div className="text-[21px] text-textcolor-black w-[180px] truncate">
          {selectedUser.self_introduction || i18n.t("MSG_PARENT_PAGE_NOT_SET")}
        </div>
        <button
          onClick={() => onEditField(ProfileFieldType.SELF_INTRODUCTION)}
          className="bg-white border border-gray2-60 text-textcolor-black rounded-full py-1.5 px-3 text-[16px] cursor-pointer hover:bg-gray2-20 transition-all shrink-0"
        >
          {i18n.t("MSG_PARENT_PAGE_CHANGE")}
        </button>
      </div>
    </div>
  );
}
